import firebase from "firebase";
import Vue from "vue"
const mainid = "s416ENLe6cIZilJrnQf0"
const state = {}

const actions = {
	save({dispatch, commit, state }, settings ){
		commit("SET_ALL",  {data: settings, collection: "assessmentSettings"}, {root: true} );
		dispatch("updateDoc", {
			doc: `assessmentDefinitions/${mainid}`, 
			action: "set", 
			data: state
		}, {root: true}).then( () => true ).catch(e => {
			console.log( e )
		})
	},
	getSettings({commit}){
		var subscription = firebase.firestore().doc(`assessmentDefinitions/${mainid}`).onSnapshot(doc => {
			commit("SET_ALL",  {data: doc.data(), collection: "assessmentSettings"}, {root:true} )
		})
		commit("auth/LOG_SUBSCRIPTION", subscription, {root: true})
	},
	newPart({state}, part ){
		state.parts.push( part )
	},
	removePart({state}, id ){
		var part = state.parts.find( p => p.id == id ); 
		state.parts.splice(	state.parts.indexOf(part), 1 );
	},
	movePart({state, commit}, {id, direction}){
		let delta = direction == "up" ? -1 : 1 ;
		var arr = state.parts;
		var index = arr.indexOf(arr.find( p => p.id == id ));
		var newIndex = index + delta;
		if (newIndex < 0  || newIndex == arr.length) return;
		var indexes = [index, newIndex].sort((a, b) => a - b); 
		arr.splice(indexes[0], 2, arr[indexes[1]], arr[indexes[0]]); 
		commit("UPDATE_SETTING",  {setting: "parts", value: arr } );
	},
	addSectionToPart({state, commit}, {part_id, section }) {
		var part = state.parts.find( p => p.id == part_id );
		if( !part.sections ){
			part.sections = [];
		}
		part.sections.push( section );
		commit("UPDATE_PART", part  );

	}	
} 

const mutations = {
	UPDATE_SETTING(state, {setting, value}){
		Vue.set(state, setting, value)
	},
	UPDATE_PART(state, part ){
		var index = state.parts.indexOf(state.parts.find( p => p.id == part.id ) );
		Vue.set(state.parts, index, part )
	}		
}

const getters = {}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
